import styled from 'styled-components'

export const Container = styled.span`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => (props.$hasError ? props.theme.colors.danger.onSurface : 'inherit')};
`

export const ErrorIndicator = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.danger.default};
`
